import { Box, CircularProgress } from '@mui/material'
import React from 'react'

export const LoadingCard: React.FC = () => {
  return (
    <Box
      display='grid'
      height='100%'
      alignItems='center'
      justifyContent='center'
      role='loading'
      data-cy='loading-card'
    >
      <CircularProgress color='primary' />
    </Box>
  )
}
